import { ShareDataTableAdapter, ShareDataRow } from '@alfresco/adf-content-services';
import { DataColumnComponent } from '@alfresco/adf-core';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { IntegrationServiceImpl } from 'integration-service/integration-service-impl';

@Component({
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss']
})
export class SMTThumbnailComponent implements OnInit {

  @Input() context: { data: ShareDataTableAdapter, row: ShareDataRow, col: DataColumnComponent };
  
  images: { icon: string, tooltip?: string } [];

  constructor(private integrationService: IntegrationServiceImpl, private cdRef: ChangeDetectorRef) {}

  async ngOnInit(): Promise<void> {
    this.images = await this.integrationService.getThumbnailImage(this.context?.row);
    this.cdRef.detectChanges();
  }

}
